import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/promiseFrame/customer-phone.png'
import _imports_1 from '../../../../assets/promiseFrame/customer-verify.png'
import _imports_2 from '../../../../assets/promiseFrame/recheck-result.png'
import _imports_3 from '../../../../assets/promiseFrame/material.png'
import _imports_4 from '../../../../assets/promiseFrame/ensure-end.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3f496a44")

_pushScopeId("data-v-3f496a44")
const _hoisted_1 = { class: "ensure-service-explain" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保障服务说明 ")
const _hoisted_4 = { class: "demo-tab-width-title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "demo-tab-width-line" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "ensure-flow"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "ensure-title" }, "承保流程", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "ensure-flex" }, [
  /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
    /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_0,
        alt: ""
      }),
      /*#__PURE__*/_createVNode("i")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, [
      /*#__PURE__*/_createTextVNode(" 拨打客服电话"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("400-808-3718 ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
    /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_1,
        alt: ""
      }),
      /*#__PURE__*/_createVNode("i")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, [
      /*#__PURE__*/_createTextVNode(" 客服核实"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("情况 ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
    /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_2,
        alt: ""
      }),
      /*#__PURE__*/_createVNode("i")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, [
      /*#__PURE__*/_createTextVNode(" 车辆复检并提"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("供复检结论 ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
    /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_3,
        alt: ""
      }),
      /*#__PURE__*/_createVNode("i")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, [
      /*#__PURE__*/_createTextVNode(" 提供所需"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("材料 ")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ensure-flex-item" }, [
    /*#__PURE__*/_createVNode("div", { class: "ensure-icon-img" }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_4,
        alt: ""
      })
    ]),
    /*#__PURE__*/_createVNode("div", { class: "ensure-icon-text" }, " 承保结束 ")
  ])
], -1)
const _hoisted_9 = {
  key: 1,
  class: "ensure-standard ensure-section"
}
const _hoisted_10 = { class: "ensure-title" }
const _hoisted_11 = { class: "ensure-text" }
const _hoisted_12 = {
  key: 0,
  class: "prop_up_height12"
}
const _hoisted_13 = {
  key: 1,
  class: "prop_up_height20"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_tab = _resolveComponent("van-tab")
  const _component_van_tabs = _resolveComponent("van-tabs")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: "ensure-service-explain-header",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, [
        _hoisted_2,
        _hoisted_3
      ]),
      _createVNode(_component_van_tabs, {
        modelValue: _ctx.state.activeName,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.activeName = $event)),
        scrollspy: "",
        sticky: ""
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.contentTextRender, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_tab, {
              key: index,
              name: item.label
            }, {
              title: _withId(() => [
                _createVNode("span", null, [
                  _createVNode("span", _hoisted_4, _toDisplayString(item.label || item.title), 1),
                  _hoisted_5
                ])
              ]),
              default: _withId(() => [
                (item.title === '承保流程')
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _hoisted_8
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, _toDisplayString(item.title), 1),
                      _createVNode("div", _hoisted_11, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.content, (itemp) => {
                          return (_openBlock(), _createBlock("p", { key: itemp }, [
                            (itemp === 'prop_up_height12')
                              ? (_openBlock(), _createBlock("span", _hoisted_12))
                              : (itemp === 'prop_up_height20')
                                ? (_openBlock(), _createBlock("span", _hoisted_13))
                                : (_openBlock(), _createBlock("span", {
                                    key: 2,
                                    innerHTML: itemp,
                                    class: {'bold': item.weight === 'bold'},
                                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goJGDesc && _ctx.goJGDesc(...args)))
                                  }, null, 10, ["innerHTML"]))
                          ]))
                        }), 128))
                      ])
                    ]))
              ]),
              _: 2
            }, 1032, ["name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
})